import { render, staticRenderFns } from "./PermitsLoader.vue?vue&type=template&id=9445b97e&"
import script from "./PermitsLoader.vue?vue&type=script&lang=js&"
export * from "./PermitsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports